<template>
  <div>
    <h1>Розклад</h1>
    <StaticGroups class="m-3" />
  </div>
</template>

<script>
import StaticGroups from "@/components/StaticGroups";
export default {
  name: "Schedule",
  components: {
    StaticGroups,
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped></style>
